module.exports = __webpack_public_path__ + "components/flag/static/square/ac-9a5a06aec3d9e286bbf97ecffa7b9da0.svg";